import "../../App.css";
import "../../styling/Gallery.css";

// Boostrap Imports
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Tab from "react-bootstrap/Tab";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";

import VideoGallery from "./VideoGallery.js";

// Mobile checks
import { useState, useEffect } from "react";
import VideoGalleryMobile from "./VideoGalleryMobile.js";

import ImageGallery from "./ImageGallery.js";

function Gallery() {
  const [width, setWidth] = useState(window.innerWidth);
  const [isMobile, setIsMobile] = useState(false);

  const handleWindowSizeChange = () => {
    setWidth(window.innerWidth);
    if (window.innerWidth <= 768) {
      // Adjust breakpoint as needed
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    // Initial check on mount
    handleWindowSizeChange();
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  return (
    <div id="gallery_page" className="gallery_background">
      <h3 className="title_header">GALLERY</h3>
      <Tab.Container defaultActiveKey="first" className="tab_header">
        <Row className="tab_header">
          <Col>
            <Nav
              className="justify-content-center option_header"
              variant="underline"
            >
              <Nav.Item>
                <Nav.Link eventKey="first">PHOTOS</Nav.Link>
              </Nav.Item>
            </Nav>
          </Col>
          <Col>
            <Nav
              className="justify-content-center option_header"
              variant="underline"
            >
              <Nav.Item>
                <Nav.Link eventKey="second">VIDEOS</Nav.Link>
              </Nav.Item>
            </Nav>
          </Col>
        </Row>
        <Row>
          <Tab.Content>
            <Tab.Pane eventKey="first">
              <ImageGallery />
            </Tab.Pane>
            <Tab.Pane eventKey="second">
              <Container className="tab_header">
                <Row className="tab_content">
                  {isMobile ? <VideoGalleryMobile /> : <VideoGallery />}
                </Row>
              </Container>
            </Tab.Pane>
          </Tab.Content>
        </Row>
      </Tab.Container>
    </div>
  );
}

export default Gallery;
